import { render, staticRenderFns } from "./CoBookingStatistics.vue?vue&type=template&id=7a36b58e&"
import script from "./CoBookingStatistics.vue?vue&type=script&lang=ts&"
export * from "./CoBookingStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports